import { Dialog } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const Header = () => {
  const { t, i18n } = useTranslation("translation");

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);

  const navigation = [
    { name: t("navigation.home"), href: "#home" },
    { name: t("navigation.vision"), href: "#about" },
    { name: t("navigation.services"), href: "#services" },
    { name: t("navigation.board"), href: "#team" },
    { name: t("navigation.contact"), href: "#contact" },
    {
      name: i18n.language === "ar" ? "English" : "العربية",
      href: i18n.language === "ar" ? "/en" : "/ar",
    },
  ];

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setHasScrolled(window.scrollY > 50);
    });

    return () => {
      window.removeEventListener("scroll", () => {});
    };
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        hasScrolled ? `bg-gray-400 shadow-md` : ``
      }`}
    >
      <nav
        className="flex items-center justify-between px-6 py-4 lg:px-8"
        aria-label="Global"
      >
        <div className="flex lg:flex-1 items-center justify-center">
          <a href="/" className="-m-1.5 p-1.5">
            <span className="sr-only">{t("mansour holding group")}</span>
            <img
              className="h-12 lg:h-18 w-auto"
              src="https://mhg-group.com/images/logo-en.png"
              alt=""
            />
          </a>
        </div>
        <div className="flex lg:hidden">
          <button
            type="button"
            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-white "
            onClick={() => setMobileMenuOpen(true)}
          >
            <span className="sr-only">{t("Open main menu")}</span>
            <Bars3Icon className="h-6 w-6" aria-hidden="true" />
          </button>
        </div>
        <div className="hidden lg:flex lg:gap-x-12">
          {navigation.map((item) => (
            <a
              key={item.name}
              href={item.href}
              className="text-lg font-semibold leading-6 text-white"
            >
              {item.name}
            </a>
          ))}
        </div>
      </nav>
      <Dialog
        as="div"
        className="lg:hidden"
        open={mobileMenuOpen}
        onClose={setMobileMenuOpen}
      >
        <div className="fixed inset-0 z-50" />
        <Dialog.Panel className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
          <div
            className="flex items-center justify-between"
            dir={i18n.language === "ar" ? "rtl" : "ltr"}
          >
            <a href="/" className=" p-1.5">
              <span className="sr-only">{t("mansour holding group")}</span>
              <img
                className="h-20 w-auto"
                src="https://mhg-group.com/images/logo-en.png"
                alt=""
              />
            </a>
            <button
              type="button"
              className="-m-2.5 rounded-md p-2.5 text-gray-700"
              onClick={() => setMobileMenuOpen(false)}
            >
              <span className="sr-only">Close menu</span>
              <XMarkIcon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
          <div
            className="mt-6 flow-root"
            dir={i18n.language === "ar" ? "rtl" : "ltr"}
          >
            <div className="-my-6 divide-y divide-gray-500/10">
              <div className="space-y-2 py-6">
                {navigation.map((item) => (
                  <a
                    key={item.name}
                    href={item.href}
                    className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                    onClick={(event) => {
                      setMobileMenuOpen(false);
                    }}
                  >
                    {item.name}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </Dialog.Panel>
      </Dialog>
    </header>
  );
};

export default Header;
